class SearchForm extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('[name="q"]');
    this.clear = this.querySelector("[data-clear]");
    this.submit = this.querySelector('[type="submit"]');

    this.input.addEventListener("input", (e) => this._toggleDirty());

    this.clear.addEventListener("click", () => {
      this._clear();
      this.input.focus();
    });
  }

  connectedCallback() {
    this.removeAttribute("typing");
  }

  disconnectedCallback() {}

  _clear() {
    this.input.value = "";
    this._toggleDirty();
  }

  _toggleDirty() {
    this.toggleAttribute("dirty", this.input.value.length);
    this.toggleAttribute("typing", this.input.value.length);
    // if (this.submit) {
    //   this.submit.disabled = !this.input.value.length;
    // }
  }
}

if (!customElements.get("search-form")) {
  customElements.define("search-form", SearchForm);
}
